module.exports = __webpack_public_path__ + "img/starr-hill-brewery.487da07b.jpg";